import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        count: 0,
        breadCrumb: [],
        userInfo: {},
        themeColor: '#5676DC',
        tabs: [{
                menuId: 0,
                name: '联盟首页',
                path: '/',
                icon: 'iconshangchuantouxiang2x'
            }, {
                menuId: 1,
                name: '新工科要闻',
                path: '/newslist?id=1',
                icon: 'iconyiliubenkekecheng'
            }, {
                menuId: 2,
                name: '工作动态',
                path: '/newslist?id=2',
                icon: 'iconyiliubenkekecheng'
            }, {
                menuId: 3,
                name: '通知公告',
                path: '/newslist?id=3',
                icon: 'iconyiliubenkekecheng'
            }, {
                menuId: 4,
                name: '政策文件',
                path: '/newslist?id=4',
                icon: 'iconyiliubenkekecheng'
            }, {
                menuId: 5,
                name: '典型案例',
                path: '/newslist?id=5',
                icon: 'iconyiliubenkekecheng'
            }, {
                menuId: 6,
                name: '组织机构',
                path: '/org',
                icon: 'iconyiliubenkekecheng'
            }, {
                menuId: 7,
                name: '关于联盟',
                path: '/about',
                icon: 'iconyiliubenkekecheng'
            }
        ]
    },
    mutations: {
        setBreadCrumb(state, breadCrumb) {
            state.breadCrumb = breadCrumb;
        },
        mergeToState(state, data) {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    const item = data[key];
                    console.debug(item);
                    state[key] = data[key]
                }
            }
            // state = { ...state, ...data };
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        }
    },
    actions: {
        asyncMergeToState({ commit }, data) {
            commit('mergeToState', data);
        },
        setUserInfoAction({ commit }, userInfo) {
            commit('setUserInfo', userInfo);
        }
    }
})

export default store;